
































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePermintaanPatologiAnatomi } from "@/store/modules/PermintaanPatologiAnatomiStore";
import PermintaanPatologiAnatomiSvc from "@/services/PermintaanPatologiAnatomi";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class PermintaanPatologiAnatomiInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  requiredRule = [v => !!v || "*Kolom ini harus diisi"];

  jenisPemeriksaanOpts = [
    { value: "histologi", label: "Histologi" },
    { value: "ajh", label: "AJH (FNAC)" },
    { value: "sitologi_cairan", label: "Sitologi Cairan" },
    { value: "pap_smear", label: "Pap Smear" },
    { value: "sitologi_swab", label: "Sitologi Swab" },
    { value: "imunohistokimia", label: "Imunohistokimia" }
  ];

  lateralisasiOpts = [
    { value: "kanan", text: "Kanan" },
    { value: "kiri", text: "Kiri" },
    { value: "bilateral", text: "Bilateral" }
  ];

  form_data = this.defaultForm();

  defaultForm() {
    const today = localISODate();
    return {
      tgl_permintaan: today,
      ruang_poli: "",
      rs_perujuk: "",
      dokter_pengirim_id: null as number | null,
      jenis_pemeriksaan: [] as string[],
      minta_h_pylori: false,
      minta_bta: false,
      jenis_cairan: "",
      endocervix_kondisi: "",
      catatan_tambahan_pemeriksaan: "",
      cairan_fiksasi: "",
      asal_organ: "",
      lateralisasi: null as string | null,
      diagnosis_klinis: "",
      keterangan_klinis: "",
      riwayat_pa_sebelumnya: ""
    };
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get storeUser() {
    return userModule.user;
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (val) {
      if (this.editData) {
        this.hydrateFromEdit();
      } else {
        this.form_data = this.defaultForm();
        if (this.storeUser?.profesi === "Dokter") {
          this.form_data.dokter_pengirim_id = this.storeUser.id;
        }
      }
    }
  }

  hydrateFromEdit() {
    const d = this.editData || {};
    this.form_data = {
      tgl_permintaan: d.tgl_permintaan || localISODate(),
      ruang_poli: d.ruang_poli || "",
      rs_perujuk: d.rs_perujuk || "",
      dokter_pengirim_id: d.dokter_pengirim?.id || null,
      jenis_pemeriksaan: Array.isArray(d.jenis_pemeriksaan) ? d.jenis_pemeriksaan : [],
      minta_h_pylori: !!d.minta_h_pylori,
      minta_bta: !!d.minta_bta,
      jenis_cairan: d.jenis_cairan || "",
      endocervix_kondisi: d.endocervix_kondisi || "",
      catatan_tambahan_pemeriksaan: d.catatan_tambahan_pemeriksaan || "",
      cairan_fiksasi: d.cairan_fiksasi || "",
      asal_organ: d.asal_organ || "",
      lateralisasi: d.lateralisasi || null,
      diagnosis_klinis: d.diagnosis_klinis || "",
      keterangan_klinis: d.keterangan_klinis || "",
      riwayat_pa_sebelumnya: d.riwayat_pa_sebelumnya || ""
    };
  }

  buildPayload() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tgl_permintaan: this.form_data.tgl_permintaan || null,
      ruang_poli: this.form_data.ruang_poli || null,
      rs_perujuk: this.form_data.rs_perujuk || null,
      dokter_pengirim_id: this.form_data.dokter_pengirim_id,
      jenis_pemeriksaan: this.form_data.jenis_pemeriksaan,
      minta_h_pylori: !!this.form_data.minta_h_pylori,
      minta_bta: !!this.form_data.minta_bta,
      jenis_cairan: this.form_data.jenis_cairan || null,
      endocervix_kondisi: this.form_data.endocervix_kondisi || null,
      catatan_tambahan_pemeriksaan: this.form_data.catatan_tambahan_pemeriksaan || null,
      cairan_fiksasi: this.form_data.cairan_fiksasi || null,
      asal_organ: this.form_data.asal_organ || null,
      lateralisasi: this.form_data.lateralisasi || null,
      diagnosis_klinis: this.form_data.diagnosis_klinis || null,
      keterangan_klinis: this.form_data.keterangan_klinis || null,
      riwayat_pa_sebelumnya: this.form_data.riwayat_pa_sebelumnya || null
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;

    if (!this.form_data.jenis_pemeriksaan.length) {
      alert("Pilih minimal 1 jenis pemeriksaan");
      return;
    }

    if (this.saving) return;
    this.saving = true;

    try {
      const payload = this.buildPayload();
      const resp = this.editData
        ? await PermintaanPatologiAnatomiSvc.update(this.editData.id, payload)
        : await PermintaanPatologiAnatomiSvc.create(payload);

      if (resp.data.status == "1") {
        await storePermintaanPatologiAnatomi.getByRegister(this.register);
        this.dialog = false;
        this.$emit("saved");
      }
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialog = false;
  }
}
